/**
 * ERP Dashboard Service
 * 
 * Serviço para buscar dados do dashboard gerencial.
 */

import api from './api'

export const erpDashboardService = {
  /**
   * Buscar dados do dashboard gerencial
   * @param {Object} filters - Filtros opcionais (period, startDate, endDate, month, year)
   * @returns {Promise} Dados do dashboard
   */
  getDashboardData: async (filters = {}) => {
    try {
      const response = await api.get('/api/erp/dashboard', { params: filters })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar dados do dashboard gerencial:', error)
      throw error
    }
  }
}
